import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_DIAG_CODES_REQUEST: '',
  GET_DIAG_CODES_SUCCESS: '',
  GET_DIAG_CODES_FAILURE: '',
};

types = setStoreTypeValues(types, 'authDiagCodes');

export default types;
